// ** React Imports
import { ReactNode, SyntheticEvent, useState } from 'react'

// ** MUI Components
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Box, { BoxProps } from '@mui/material/Box'

import { Link, useLocation } from 'react-router-dom'

// ** Layout Import
import BlankLayout from 'src/materio/@core/layouts/BlankLayout'

// ** Demo Imports
import FooterIllustrations from 'src/materio/views/pages/misc/FooterIllustrations'
import { client } from '../../utils/axios-client'
import { sendActivationEmailEndpoint } from '../../configs/endpoints'

// ** Styled Components
const BoxWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        width: '90vw'
    }
}))

const Img = styled('img')(({ theme }) => ({
    [theme.breakpoints.down('lg')]: {
        height: 450,
        marginTop: theme.spacing(10)
    },
    [theme.breakpoints.down('md')]: {
        height: 400
    },
    [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(16)
    }
}))

interface LocationState {
    email: string
}

const ActivateAccountScreen = () => {
    const [emailSent, setEmailSent] = useState(false);
    const { state } = useLocation();
    const { email } = state as LocationState;

    const confirmEmail = async (e: SyntheticEvent) => {
        e.preventDefault()

        client.post(sendActivationEmailEndpoint, { email });

        setEmailSent(true);
    }

    return (
        <Box className='content-center'>
            <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <BoxWrapper>
                    <Box sx={{ mb: 5.75, textAlign: 'center' }}>
                        <Typography variant='h5' sx={{ mb: 1, fontSize: '1.5rem !important' }}>
                            Activate your account 🚀
                        </Typography>
                        <Typography variant='body2' sx={{ mb: 1, fontSize: '1rem !important' }}>
                            We sent a activation email to:
                        </Typography>
                        <Typography variant='body2' sx={{ mb: 1, fontSize: '1rem !important', fontWeight: 'bold' }}>
                            {email}
                        </Typography>
                        <Typography variant='body2' sx={{ mb: 1, fontSize: '1rem !important' }}>
                            Check your email and click on the confirmation link to continue.
                        </Typography>
                        <Typography variant='body2' sx={{ mt: 2, fontSize: '1rem !important' }}>
                            <Link to="" onClick={confirmEmail}>Resend email</Link>
                        </Typography>

                        {emailSent && <Typography variant='body2' sx={{ mt: 2, fontSize: '1rem !important' }}>
                            Email sent.
                        </Typography>}
                    </Box>
                </BoxWrapper>
                <Img height='487' alt='coming-soon-illustration' src='/images/pages/misc-coming-soon.png' />
            </Box>
            <FooterIllustrations />
        </Box>
    )
}

ActivateAccountScreen.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>
ActivateAccountScreen.guestGuard = true

export default ActivateAccountScreen
